"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestOrigin = void 0;
var RequestOrigin;
(function (RequestOrigin) {
    RequestOrigin[RequestOrigin["DriverApi"] = 1] = "DriverApi";
    RequestOrigin[RequestOrigin["WebApi"] = 2] = "WebApi";
    RequestOrigin[RequestOrigin["RakeService"] = 3] = "RakeService";
    RequestOrigin[RequestOrigin["ScheduledRakeTask"] = 4] = "ScheduledRakeTask";
    RequestOrigin[RequestOrigin["CustomerExperienceApi"] = 5] = "CustomerExperienceApi";
    RequestOrigin[RequestOrigin["OpenFleetApi"] = 6] = "OpenFleetApi";
    RequestOrigin[RequestOrigin["FloatingInventoryApp"] = 7] = "FloatingInventoryApp";
    RequestOrigin[RequestOrigin["AutomationPlatform"] = 8] = "AutomationPlatform";
})(RequestOrigin || (exports.RequestOrigin = RequestOrigin = {}));
//# sourceMappingURL=request_origin.js.map